import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d30daa0")

_pushScopeId("data-v-6d30daa0")
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("E-mail")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Entrar ")
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ou-container" }, [
  /*#__PURE__*/_createVNode("p", { class: "ou" }, [
    /*#__PURE__*/_createVNode("span", null, "ou")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Entrar com Telefone ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Entrar com o Google ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Entrar com a Apple ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Entrar com Senha ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Cadastrar")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_simple_header = _resolveComponent("simple-header")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_chat_button = _resolveComponent("chat-button")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_simple_header, {
            title: "Junte-se a nós",
            "header-img": "assets/registerHeader.png",
            "has-go-back": false,
            "has-go-back-modal": $props.isModal
          }, null, 8, ["has-go-back-modal"]),
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_ion_item, { class: "no-padding email" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withId(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
                    type: "email",
                    autocomplete: "email",
                    enterkeyhint: "send",
                    onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => ($options.goConfirmLogin()), ["enter"]))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                expand: "full",
                shape: "round",
                color: "primary",
                class: "btn-entrar",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.goConfirmLogin()))
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _hoisted_5,
              _createVNode(_component_ion_button, {
                expand: "full",
                shape: "round",
                color: "dark",
                fill: "outline",
                class: "btn-entrar-telefone",
                onClick: $options.goLoginWithPhone
              }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ion_button, {
                id: "btn-google",
                expand: "full",
                shape: "round",
                color: "dark",
                fill: "outline",
                class: "btn-google",
                onClick: $options.goLoginWithGoogle
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "start",
                    class: "google-button-image",
                    src: "/google-color.svg"
                  }),
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]),
              ($setup.isPlatform('ios') && $setup.isPlatform('capacitor'))
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 0,
                    expand: "full",
                    shape: "round",
                    class: "btn-apple",
                    onClick: $options.goLoginWithApple
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_img, {
                        slot: "start",
                        class: "apple-button-image",
                        src: "assets/logoApple.png"
                      }),
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_button, {
                expand: "full",
                shape: "round",
                color: "primary",
                class: "btn-entrar-senha",
                onClick: $options.goLoginWithPassword
              }, {
                default: _withId(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ion_button, {
                expand: "full",
                shape: "round",
                color: "primary",
                fill: "outline",
                class: "btn-cadastrar",
                onClick: $options.goRegister
              }, {
                default: _withId(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createVNode(_component_chat_button)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})